<template>
  <v-app>
    <mobile-nav v-if="$vuetify.breakpoint.mobile" @toggledrawer="drawer = !drawer"></mobile-nav>
    <mobile-drawer v-if="$vuetify.breakpoint.mobile" :value="drawer" @toggledrawer="drawer = $event"></mobile-drawer>

    <dialog-box v-bind="$store.state.dialog"></dialog-box>
    <v-fade-transition>
      <loader v-if="this.$store.state.auth.status === 'loading' || this.$store.state.user.status === 'loading' || this.$store.state.status.loading"></loader>
    </v-fade-transition>
    <v-main class="pa-0">
      <v-container class="pa-0 fill-height" fluid>
        <router-view/>
      </v-container>
    </v-main>
  </v-app>
</template>

<style lang="scss">
  @import "@/scss/style";
</style>

<script>
import loader from '@/components/Loader'
import dialogBox from '@/components/DialogBox'
import axios from 'axios'
import mobileNav from '@/components/NavMobile'
import mobileDrawer from '@/components/MobileDrawer'

axios.defaults.withCredentials = true

export default {
    name: 'App',
    components: { loader, dialogBox, mobileNav, mobileDrawer },
    data: () => {
      return {
        drawer: false
      }
    },
    async created () {
    }
}
</script>


